import { Ref } from 'vue'

export const viewOnlyKey = Symbol()
export interface ViewOnlyInterface {
  viewOnly: Ref<Boolean>
}
